import Vue from "vue";
import Router from "vue-router";
import store from "../store";
import HomePage from "../components/guest/HomePage.vue";
import OurSolutions from "../components/guest/our_solutions/OurSolutions.vue";
import SignUpPage from "../components/guest/sign_up/SignUpPage.vue";
import Login from "../components/guest/Login.vue";
import PageNotFound from "../components/guest/404.vue";
import ForgotPassword from "../components/guest/ForgotPassword.vue";
import { setAdReferrerDetails } from "../helpers/ad_tracking/set_ad_tracking_details";
import { tebaDomainRedirect } from "../helpers/url/teba_domain_redirect";
import Home from "../components/guest/home/Home.vue";
import HowItWorks from "../components/guest/how_it_works/HowItWorks.vue";
import Articles from "../components/guest/articles/Articles.vue";
import Article from "../components/guest/articles/Article.vue";
import FAQs from "../components/guest/faqs/FAQs.vue";
import EstateAdministrationCostCalculatorContainer from "../components/guest/EstateCostCalculator/EstateAdministrationCostCalculatorContainer.vue";
import EstateAdministrationCostCalculatorContainerQW from "../components/guest/EstateCostCalculator/EstateAdministrationCostCalculatorContainerQW.vue";
import { landingPages, redesign } from "../helpers/routes/route-helper";
import whitelabel from "../whitelabel-config";
import LandingSimple from "../components/guest/home/LandingSimple.vue";
import SignupContainer from "../components/guest/sign_up/SignupContainer.vue";
import LoginContainer from "../components/guest/login/LoginContainer.vue";
import AdviserEnrolment from "../components/guest/advisers/AdviserEnrolment.vue";
import CalculatorsContainer from "../components/guest/calculators/CalculatorsContainer.vue";
import Home1 from "../components/guest/home/Home1.vue";
import Home2 from "../components/guest/home/Home2.vue";
import Home3 from "../components/guest/home/Home3.vue";

const OverviewPage = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/overview/OverviewPage.vue"
  );
const PaymentPlanPage = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/payment/PaymentPlanPage.vue"
  );
const BasicPaymentPage = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/payment/BasicPaymentPage.vue"
  );
const SuccessPaymentPage = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/payment/SuccessPaymentPage.vue"
  );
const AnnualSubscriptionPage = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/payment/AnnualSubscriptionPage.vue"
  );
const AboutYourself = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/about_yourself/AboutYourself.vue"
  );
const YourPeople = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/people/YourPeople.vue"
  );
const PeopleOverview = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/people/PeopleOverview.vue"
  );
const AreYouMarried = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/people/AreYouMarried.vue"
  );
const YourSpouse = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/people/YourSpouse.vue"
  );
const MaritalRegime = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/people/MaritalRegime.vue"
  );
const DoYouHaveChildren = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/people/DoYouHaveChildren.vue"
  );
const AddChildren = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/people/AddChildren.vue"
  );
const ChildrensGuardian = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/people/ChildrensGuardian.vue"
  );
const ChildrensTrust = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/people/ChildrensTrust.vue"
  );
const AppointExecutor = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/people/AppointExecutor.vue"
  );
const OptionalInheritors = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/people/OptionalInheritors.vue"
  );
const AssetsBase = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/assets/AssetsBase.vue"
  );
const WorldWideAssets = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/assets/WorldWideAssets.vue"
  );
const AssetsOverview = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/assets/AssetsOverview.vue"
  );
const SpecificDonationsOverview = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/specific_donations/SpecificDonationsOverview.vue"
  );
const AssetDonation = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/specific_donations/AssetDonation.vue"
  );
const MoneyDonation = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/specific_donations/MoneyDonation.vue"
  );
const RemainderOfEstateBase = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/remainder_of_estate/RemainderOfEstateBase.vue"
  );
const RemainderOfEstateDistribution = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/remainder_of_estate/RemainderOfEstateDistribution.vue"
  );
const RemainderOfEstateAlternative = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/remainder_of_estate/RemainderOfEstateAlternative.vue"
  );
const DistributionSpecificPercentages = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/remainder_of_estate/DistributionSpecificPercentages.vue"
  );
const DistributionSpecificPercentageAlternatives = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/remainder_of_estate/DistributionSpecificPercentageAlternatives.vue"
  );
const AlternativeDistributionSpecificPercentages = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/remainder_of_estate/AlternativeDistributionSpecificPercentages.vue"
  );
const LetterOfWishes = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/letter_of_wishes/LetterOfWishes.vue"
  );
const LivingWill = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/letter_of_wishes/LivingWill.vue"
  );
const LetterOfWishesAndLivingWillBase = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/letter_of_wishes/LetterOfWishesAndLivingWillBase.vue"
  );
const ManageAccount = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/manage_account/ManageAccount.vue"
  );
const AssetListPdf = () => import("../components/assets/AssetListPdf.vue");
const DownloadWillLoadingPage = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/loading/DownloadWillLoadingPage.vue"
  );
const AdminPage = () =>
  import(/* webpackChunkName: "admin" */ "../components/admin/AdminPage.vue");
const LeadProvider = () =>
  import(
    /* webpackChunkName: "admin" */ "../components/admin/LeadProvider.vue"
  );
const WillSummary = () =>
  import(
    /* webpackChunkName: "admin" */ "../components/admin/will_summary/WillSummary.vue"
  );
const WillVerification = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/will_verification/WillVerification.vue"
  );
const AddUser = () =>
  import(/* webpackChunkName: "admin" */ "../components/admin/AddUser.vue");
const InsuranceBase = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/insurance/InsuranceBase.vue"
  );
const InsuranceExplanation = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/insurance/InsuranceExplanation.vue"
  );
const InsuranceQuestions = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/insurance/InsuranceQuestions.vue"
  );
const InsuranceQuote = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/insurance/InsuranceQuote.vue"
  );
const InsuranceImportantInfo = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/insurance/ImportantInfo.vue"
  );
const InsuranceBankingDetails = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/insurance/InsuranceBankingDetails.vue"
  );
const InsurancePolicyConfirmation = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/insurance/InsurancePolicyConfirmation.vue"
  );
const EstimatedInsuranceRequired = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/insurance/EstimatedInsuranceRequired.vue"
  );
const EstimatedInsuranceRequiredInput = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/insurance/EstimatedInsuranceRequiredInput.vue"
  );
const EstimatedInsuranceRequiredOutput = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/insurance/EstimatedInsuranceRequiredOutput.vue"
  );
const GetFreeInsuranceQuote = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/insurance/GetFreeInsuranceQuote.vue"
  );
const InsuranceQuotes = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/insurance/InsuranceQuotes.vue"
  );
const InsuranceProducts = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/insurance/InsuranceProducts.vue"
  );
const LearnMore = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/insurance/LearnMore.vue"
  );
const LearnMoreOld = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/insurance/LearnMoreOld.vue"
  );
const OldMutualTermsAndConditions = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/old_mutual/OldMutualTermsAndConditions.vue"
  );
const OldMutualPrivacyPolicy = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/old_mutual/OldMutualPrivacyPolicy.vue"
  );
const CompetitionTermsAndConditions = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/old_mutual/CompetitionTermsAndConditions.vue"
  );
const InsuranceAgeRestricted = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/insurance/AgeRestricted.vue"
  );
const InsuranceNonSACitizen = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/insurance/NonSACitizen.vue"
  );
const RequestAdvisorCall = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/insurance/RequestAdvisorCall.vue"
  );
const PolicySuccessPage = () =>
  import(
    /* webpackChunkName: "loggedIn" */ "../components/insurance/PolicySuccessPage.vue"
  );
const CompaniesPage = () =>
  import(
    /* webpackChunkName: "admin" */ "../components/admin/companies/CompaniesPage.vue"
  );
const DailyTasksPage = () =>
  import(
    /* webpackChunkName: "admin" */ "../components/admin/DailyTasksPage.vue"
  );
const CompanyPage = () =>
  import(
    /* webpackChunkName: "admin" */ "../components/admin/companies/CompanyPage.vue"
  );
const BranchesPage = () =>
  import(
    /* webpackChunkName: "admin" */ "../components/admin/companies/BranchesPage.vue"
  );
const AuditTrail = () =>
  import(/* webpackChunkName: "admin" */ "../components/admin/AuditTrail.vue");
const UserLinkLandingPage = () =>
  import(
    /* webpackChunkName: "landingPage" */ "../components/guest/user_links/UserLinkLandingPage.vue"
  );
const UserLinkLandingPageRedesign = () =>
  import(
    /* webpackChunkName: "landingPage" */ "../components/guest/user_links/UserLinkLandingPageRedesign.vue"
  );
const AdvisorPage = () =>
  import(
    /* webpackChunkName: "advisorPage" */ "../components/guest/AdvisorPage.vue"
  );
const ExecutorExplainer = () =>
  import(
    /* webpackChunkName: "executorExplainer" */ "../components/guest/ExecutorExplainer.vue"
  );
const Referrals = () =>
  import(
    /* webpackChunkName: "referrals" */ "../components/referrals/Referrals.vue"
  );
const AdvisorDashboard = () =>
  import(
    /* webpackChunkName: "advisorDashboard" */ "../components/advisors/AdvisorDashboard.vue"
  );

const EmergencyContacts = () =>
  import(
    /* webpackChunkName: "emergencyContacts" */ "../components/people/EmergencyContacts.vue"
  );

Vue.use(Router);

let router = new Router({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve({ selector: to.hash, offset: { x: 0, y: 25 } });
        }, 20);
      });
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      path: "/",
      name: redesign() ? "HomeAlternative" : "Home",
      component: redesign() ? Home : HomePage,
      meta: {
        guest: true,
      },
    },
    {
      path: "/create-your-will",
      name: landingPages() ? "Home1" : "Home",
      component: landingPages() ? Home1 : HomePage,
      meta: {
        guest: true,
      },
    },
    {
      path: "/your-free-will",
      name: landingPages() ? "Home2" : "Home",
      component: landingPages() ? Home2 : HomePage,
      meta: {
        guest: true,
      },
    },
    {
      path: "/free-will-template",
      name: landingPages() ? "Home3" : "Home",
      component: landingPages() ? Home3 : HomePage,
      meta: {
        guest: true,
      },
    },

    {
      path: "/getstarted",
      name: redesign() ? "LandingSimple" : "Home",
      component: redesign() ? LandingSimple : HomePage,
      meta: {
        guest: true,
      },
    },
    {
      path: "/our-solutions",
      name: "OurSolutions",
      component: OurSolutions,
      beforeEnter: (to, from, next) => {
        if (redesign()) {
          next();
        } else {
          next("/");
        }
      },
      meta: {
        guest: true,
      },
    },
    {
      path: "/referrals",
      name: "Referrals",
      component: Referrals,
      meta: {
        requiresAuth: true,
        onlyTestator: true,
      },
    },
    {
      path: "/signup",
      name: "SignUpPage",
      component: SignUpPage,
      meta: {
        guest: true,
      },
    },
    {
      path: "/register",
      name: "Register",
      component: SignupContainer,
      meta: {
        guest: true,
      },
    },
    {
      path: "/Login",
      name: "Login",
      component: LoginContainer,
      meta: {
        guest: true,
      },
    },
    {
      path: "/login-qw",
      name: "Login",
      component: Login,
      props: true,
      meta: {
        guest: true,
      },
    },
    {
      path: "/executor-explainer",
      name: "ExecutorExplainer",
      component: ExecutorExplainer,
    },
    {
      path: "/for-business",
      name: "AdvisorPage",
      component: AdvisorPage,
      meta: {
        guest: true,
      },
    },
    {
      path: "/adviser",
      name: "AdviserEnrolment",
      component: AdviserEnrolment,
      meta: {
        guest: true,
      },
      beforeEnter: (to, from, next) => {
        const brand = process.env.VUE_APP_BRAND;
        if (brand === "oldmutual") {
          next();
        } else {
          next({
            name: "PageNotFound",
            params: { pathMatch: to.path.substring(1).split("/") },
          });
        }
      },
    },
    {
      path: "/estate-administration-cost-calculator",
      name: "EstateAdministrationCostCalculator",
      component: redesign()
        ? EstateAdministrationCostCalculatorContainer
        : EstateAdministrationCostCalculatorContainerQW,
      meta: {
        guest: true,
      },
    },
    {
      path: "/calculators",
      name: "Calculators",
      component: redesign()
        ? CalculatorsContainer
        : EstateAdministrationCostCalculatorContainerQW,
      meta: {
        guest: true,
      },
    },
    {
      path: "/how-it-works",
      name: "HowItWorks",
      component: HowItWorks,
      beforeEnter: (to, from, next) => {
        if (redesign()) {
          next();
        } else {
          next("/#how-it-works");
        }
      },
      meta: {
        guest: true,
      },
    },
    {
      path: "/articles",
      name: "Articles",
      component: Articles,
      beforeEnter: (to, from, next) => {
        if (redesign()) {
          next();
        } else {
          next("/");
        }
      },
    },
    {
      name: "Article",
      path: "/articles/:title",
      component: Article,
      beforeEnter: (to, from, next) => {
        if (redesign()) {
          next();
        } else {
          next("/");
        }
      },
      props: true,
    },
    {
      name: "FAQs",
      path: "/faqs",
      component: FAQs,
      beforeEnter: (to, from, next) => {
        if (redesign()) {
          next();
        } else {
          next("/");
        }
      },
    },
    {
      name: "CGT Calculator",
      path: "/cgt-calculator",
      component: CalculatorsContainer,
      props: (route) => ({
        activeTab: 1,
        hideTabs: true,
      }),
    },
    {
      name: "Estate Cost Calculator",
      path: "/estate-cost-calculator",
      component: CalculatorsContainer,
      props: (route) => ({
        activeTab: 0,
        hideTabs: true,
      }),
    },
    {
      path: "/terms-and-conditions",
      name: "TermsAndConditions",
      component: OldMutualTermsAndConditions,
    },
    {
      path: "/privacy-policy",
      name: "PrivacyPolicy",
      component: OldMutualPrivacyPolicy,
    },
    {
      path: "/competition-terms-and-conditions",
      name: "CompetitionTermsAndConditions",
      component: CompetitionTermsAndConditions,
    },
    {
      path: "/overview",
      name: "OverviewPage",
      component: OverviewPage,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/payment-plan",
      name: "PaymentPlanPage",
      component: PaymentPlanPage,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/basic-payment",
      name: "BasicPaymentPage",
      component: BasicPaymentPage,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/annual-subscription",
      name: "AnnualSubscriptionPage",
      component: AnnualSubscriptionPage,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/success-payment",
      name: "SuccessPaymentPage",
      component: SuccessPaymentPage,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/about-yourself",
      name: "AboutYourself",
      component: AboutYourself,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/people",
      name: "YourPeople",
      component: YourPeople,
      props: true,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "married",
          name: "Married",
          component: AreYouMarried,
          meta: {
            peopleWizard: true,
          },
        },
        {
          path: "spouse",
          name: "YourSpouse",
          component: YourSpouse,
          meta: {
            peopleWizard: true,
          },
        },
        {
          path: "marital-regime",
          name: "MaritalRegime",
          component: MaritalRegime,
          meta: {
            peopleWizard: true,
          },
        },
        {
          path: "children",
          name: "Children",
          component: DoYouHaveChildren,
          meta: {
            peopleWizard: true,
          },
        },
        {
          path: "add-children",
          name: "AddChildren",
          component: AddChildren,
          meta: {
            peopleWizard: true,
          },
        },
        {
          path: "guardian",
          name: "ChildrensGuardian",
          component: ChildrensGuardian,
          meta: {
            peopleWizard: true,
          },
        },
        {
          path: "trust",
          name: "ChildrensTrust",
          component: ChildrensTrust,
          meta: {
            peopleWizard: true,
          },
        },
        {
          path: "emergency-contacts",
          name: "EmergencyContacts",
          component: EmergencyContacts,
          meta: {
            peopleWizard: true,
          },
        },
        {
          path: "executor",
          name: "AppointExecutor",
          component: AppointExecutor,
          meta: {
            peopleWizard: true,
          },
        },
        {
          path: "optional-inheritors",
          name: "OptionalInheritors",
          component: OptionalInheritors,
        },
      ],
    },
    {
      path: "/people-overview",
      name: "PeopleOverview",
      component: PeopleOverview,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/assets-base",
      name: "AssetsBase",
      component: AssetsBase,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "/world-wide-assets",
          name: "WorldWideAssets",
          component: WorldWideAssets,
        },
        {
          path: "/assets-overview",
          name: "AssetsOverview",
          component: AssetsOverview,
        },
      ],
    },
    {
      path: "/specific-donations",
      name: "SpecificDonationsOverview",
      component: SpecificDonationsOverview,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/specific-bequests-remainder-of-estate",
      name: "SpecificDonationsRemainderOfEstateOverview",
      component: SpecificDonationsOverview,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/specific-donations-assets",
      name: "AssetDonation",
      component: AssetDonation,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/remainder-of-estate-specific-donations-assets",
      name: "RemainderOfEstateAssetDonation",
      component: AssetDonation,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/specific-donations-money",
      name: "MoneyDonation",
      component: MoneyDonation,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/remainder-of-estate-specific-donations-money",
      name: "RemainderOfEstateMoneyDonation",
      component: MoneyDonation,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/remainder-of-estate",
      name: "RemainderOfEstateBase",
      component: RemainderOfEstateBase,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "distribution",
          name: "RemainderOfEstateDistribution",
          component: RemainderOfEstateDistribution,
        },
        {
          path: "alternative-distribution",
          name: "RemainderOfEstateAlternative",
          component: RemainderOfEstateAlternative,
        },
        {
          path: "distribution-specific-percentages",
          name: "DistributionSpecificPercentages",
          component: DistributionSpecificPercentages,
        },
        {
          path: "distribution-specific-percentage-alternative/:id",
          name: "DistributionSpecificPercentageAlternatives",
          component: DistributionSpecificPercentageAlternatives,
        },
        {
          path: "alternative-distribution-specific-percentages",
          name: "AlternativeDistributionSpecificPercentages",
          component: AlternativeDistributionSpecificPercentages,
        },
      ],
    },
    {
      path: "/letter-of-wishes-and-living-will",
      name: "LetterOfWishesAndLivingWillBase",
      component: LetterOfWishesAndLivingWillBase,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "/letter-of-wishes",
          name: "LetterOfWishes",
          component: LetterOfWishes,
        },
        {
          path: "/living-will",
          name: "LivingWill",
          component: LivingWill,
        },
      ],
    },
    {
      path: "/manage-account",
      name: "ManageAccount",
      component: ManageAccount,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/forgot-password",
      name: "ForgotPassword",
      component: ForgotPassword,
      meta: {
        guest: true,
      },
    },
    {
      path: "/asset-list-pdf/:id",
      name: "AssetListPdf",
      component: AssetListPdf,
    },
    {
      path: "/generating-will",
      name: "DownloadWillLoadingPage",
      component: DownloadWillLoadingPage,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/lead-provider",
      name: "LeadProvider",
      component: LeadProvider,
      meta: {
        requiresAuth: true,
        leadProvider: true,
      },
    },
    {
      path: "/admin",
      name: "AdminPage",
      component: AdminPage,
      props: true,
      meta: {
        admin: true,
      },
    },
    {
      path: "/advisors/will-summary/:id",
      name: "WillSummary",
      component: WillSummary,
      props: true,
      meta: {
        admin: true,
      },
    },
    {
      path: "/will-verification",
      name: "WillVerification",
      component: WillVerification,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/advisors/add-user",
      name: "AddUser",
      component: AddUser,
      meta: {
        admin: true,
      },
    },
    {
      path: "/insurance",
      name: "InsuranceBase",
      component: InsuranceBase,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "explanation",
          name: "InsuranceExplanation",
          component: InsuranceExplanation,
          meta: {
            showOmartImg: true,
          },
        },
        {
          path: "questions",
          name: "InsuranceQuestions",
          component: InsuranceQuestions,
          meta: {
            showOmartImg: true,
            hideIfPolicyExists: true,
          },
        },
        {
          path: "quote",
          name: "InsuranceQuote",
          component: InsuranceQuote,
          meta: {
            showOmartImg: true,
            hideIfPolicyExists: true,
          },
        },
        {
          path: "estimated-insurance-required-output",
          name: "EstimatedInsuranceRequiredOutput",
          component: EstimatedInsuranceRequiredOutput,
          meta: {
            showOmartImg: true,
          },
        },
        {
          path: "get-free-insurance-quote",
          name: "GetFreeInsuranceQuote",
          component: GetFreeInsuranceQuote,
          meta: {
            showOmartImg: true,
          },
        },
        {
          path: "insurance-quotes",
          name: "InsuranceProducts",
          component: InsuranceProducts,
          meta: {
            showOmartImg: true,
          },
        },
        {
          path: "learn-more",
          name: "LearnMore",
          component: whitelabel(process.env.VUE_APP_BRAND).estateAssistEnabled
            ? LearnMore
            : LearnMoreOld,
          meta: {
            showOmartImg: true,
          },
        },
        {
          path: "age-restricted",
          name: "InsuranceAgeRestricted",
          component: InsuranceAgeRestricted,
        },
        {
          path: "non-sa-citizen",
          name: "InsuranceNonSACitizen",
          component: InsuranceNonSACitizen,
        },
        {
          path: "request-advisor-call",
          name: "RequestAdvisorCall",
          component: RequestAdvisorCall,
        },
        {
          path: "estimated-insurance-required",
          name: "EstimatedInsuranceRequired",
          component: EstimatedInsuranceRequired,
          meta: {
            showOmartImg: true,
            hideIfPolicyExists: true,
          },
        },
        {
          path: "important-info",
          name: "InsuranceImportantInfo",
          component: InsuranceImportantInfo,
          meta: {
            showOmartImg: true,
            hideIfPolicyExists: true,
          },
        },
        {
          path: "estimated-insurance-required-input",
          name: "EstimatedInsuranceRequiredInput",
          component: EstimatedInsuranceRequiredInput,
          meta: {
            showOmartImg: true,
          },
        },
        {
          path: "banking-details",
          name: "InsuranceBankingDetails",
          component: InsuranceBankingDetails,
          meta: {
            showOmartImg: true,
            hideIfPolicyExists: true,
          },
        },
        {
          path: "policy-confirmation",
          name: "InsurancePolicyConfirmation",
          component: InsurancePolicyConfirmation,
          meta: {
            showOmartImg: true,
          },
        },
        {
          path: "policy-success",
          name: "PolicySuccessPage",
          component: PolicySuccessPage,
          meta: {
            showOmartImg: true,
          },
        },
      ],
    },
    {
      path: "/advisors/daily-tasks",
      name: "DailyTasksPage",
      component: DailyTasksPage,
      meta: {
        onlyAdmin: true,
      },
    },
    {
      path: "/advisors/companies",
      name: "CompaniesPage",
      component: CompaniesPage,
      meta: {
        onlyAdmin: true,
      },
    },
    {
      path: "/advisors/company/:id",
      name: "CompanyPage",
      component: CompanyPage,
      props: true,
      meta: {
        onlyCompanyAdmin: true,
      },
    },
    {
      path: "/advisors/company/:id/branches",
      name: "BranchesPage",
      component: BranchesPage,
      props: true,
      meta: {
        onlyCompanyAdmin: true,
      },
    },
    {
      path: "/reset-password/:id",
      name: "UserLinkLandingPage",
      component: UserLinkLandingPage,
    },

    // Shortened url for reset-password
    {
      path: "/r/:id",
      name: redesign() ? "UserLinkLandingPageRedesign" : "UserLinkLandingPage",
      component: redesign() ? UserLinkLandingPageRedesign : UserLinkLandingPage,
    },
    // {
    //   // Shortened url for reset-password
    //   path: "/r/:id",
    //   name: "UserLinkLandingPage",
    //   component: UserLinkLandingPage,
    // },
    {
      path: "/advisors/audit-trail/:id",
      name: "AuditTrail",
      component: AuditTrail,
      meta: {
        onlyAdmin: true,
      },
    },
    {
      // Old mutual legacy path
      path: "/system/portal/*",
      redirect: "/",
    },
    {
      // Old mutual legacy path
      path: "/system/portal",
      redirect: "/",
    },
    //Old Mutual Legacy articles permanent 301 redirects
    {
      path: "/articlescreate-your-will",
      redirect: "/",
      meta: { statusCode: 301 },
    },
    {
      path: "/articleswhy-do-you-need-a-professional-executor-and-what-do-they-do",
      redirect: "/articles/executor-of-will-why-do-you-need-a-professional",
      meta: { statusCode: 301 },
    },
    {
      path: "/articlesold-mutual-will-faqs",
      redirect: "/faqs",
      meta: { statusCode: 301 },
    },
    {
      path: "/articlesexecutor",
      redirect: "articles/executor-of-will-why-do-you-need-a-professional",
      meta: { statusCode: 301 },
    },
    {
      path: "/articleswills-in-south-africa-70-of-south-africans-die-without-a-will",
      redirect: "/articles/wills-in-south-africa",
      meta: { statusCode: 301 },
    },
    {
      path: "/create-your-will",
      redirect: "/",
      meta: { statusCode: 301 },
    },
    {
      path: "/why-do-you-need-a-professional-executor-and-what-do-they-do",
      redirect: "/articles/executor-of-will-why-do-you-need-a-professional",
      meta: { statusCode: 301 },
    },
    {
      path: "/wills-in-south-africa-70-of-south-africans-die-without-a-will",
      redirect: "/articles/wills-in-south-africa",
      meta: { statusCode: 301 },
    },
    {
      path: "/old-mutual-will-faqs",
      redirect: "/faqs",
      meta: { statusCode: 301 },
    },
    {
      path: "/executor",
      redirect: "/articles/executor-of-will-why-do-you-need-a-professional",
      meta: { statusCode: 301 },
    },
    {
      path: "/advisors",
      name: "AdvisorDashboard",
      component: AdvisorDashboard,
      props: true,
      meta: {
        admin: true,
      },
    },
    // PageNotFound should always be last
    {
      path: "*",
      name: "PageNotFound",
      component: PageNotFound,
    },
  ],
});

router.beforeEach((to, from, next) => {
  // Block all routes for lead providers
  if (store.getters.isLeadProvider && to.name != "LeadProvider") {
    next("/lead-provider");
    return;
  }

  setAdReferrerDetails(to, store);
  tebaDomainRedirect();
  if (
    store.getters.isLoggedIn &&
    [
      "HomeAlternative",
      "Articles",
      "Article",
      "HowItWorks",
      "FAQs",
      "EstateAdministrationCostCalculator",
    ].includes(to.name)
  ) {
    store.dispatch("logout").then(() => {
      next(to.path);
    });
  }

  const hasMmatchedRecords = to.matched.some(
    (record) => record.meta.requiresAuth
  );

  if (hasMmatchedRecords) {
    if (to.matched.some((record) => record.meta.onlyTestator)) {
      if (!store.getters.isTestator) {
        next("/overview");
      }
    }

    // Handle redirecting to /login if not logged in
    if (store.getters.isLoggedIn) {
      // Handle passing the peopleWizard param around
      if (
        to.matched.some((record) => record.meta.peopleWizard) &&
        from.query.peopleWizard &&
        from.query.peopleWizard != to.query.peopleWizard
      ) {
        next({
          path: to.path,
          query: { ...from.query, peopleWizard: from.query.peopleWizard },
        });
      } else {
        next();
      }
    } else {
      next({
        path: "/",
      });
    }
  } else if (to.matched.some((record) => record.meta.admin)) {
    // only allow admins, company admins and advisors to access admin pages
    if (
      store.getters.isAdmin ||
      store.getters.isAdvisor ||
      store.getters.isCompanyAdmin ||
      store.getters.isFiduciaryConsultant ||
      store.getters.isCallCenterAgent ||
      store.getters.isBranchAgent
    ) {
      next();
    } else {
      next("/");
    }
  } else if (to.matched.some((record) => record.meta.leadProvider)) {
    // only allow lead providers to access lead provider pages
    if (store.getters.isLeadProvider) {
      next();
    } else {
      next("/");
    }
  } else if (to.matched.some((record) => record.meta.onlyAdmin)) {
    // only allow admins to access onlyAdmin pages
    if (store.getters.isAdmin) {
      next();
    } else {
      next("/");
    }
  } else if (to.matched.some((record) => record.meta.onlyCompanyAdmin)) {
    // only allow company admins and admins
    if (store.getters.isCompanyAdmin || store.getters.isAdmin) {
      next();
    } else {
      next("/");
    }
  } else if (to.matched.some((record) => record.meta.guest)) {
    // if logged in redirect to app if on guest page
    if (store.getters.isLoggedIn) {
      next("/overview");
    } else {
      next();
    }
  } else {
    next();
  }
});

router.afterEach((to, from) => {
  const { fullPath } = to;
  window.dataLayer = window.dataLayer || [];

  switch (fullPath) {
    case "/#how-it-works":
      window.dataLayer.push({
        event: "how-it-works",
        omuserid: store.getters?.userId,
      });
      break;

    case "/signup":
      window.dataLayer.push({
        event: "signup",
        omuserid: store.getters?.userId,
      });
      break;

    case "/manage-account":
      window.dataLayer.push({
        event: "manage-account",
        omuserid: store.getters?.userId,
      });
      break;

    case "/overview":
      window.dataLayer.push({
        event: "overview",
        omuserid: store.getters?.userId,
      });
      break;

    case "/about-yourself":
      window.dataLayer.push({
        event: "about-yourself",
        omuserid: store.getters?.userId,
      });
      break;

    case "/overview#about-yourself":
      window.dataLayer.push({
        event: "overview-about-yourself",
        omuserid: store.getters?.userId,
      });
      break;

    case "/people/married":
      window.dataLayer.push({
        event: "your-people-married",
        omuserid: store.getters?.userId,
      });
      break;

    case "/people/spouse":
      window.dataLayer.push({
        event: "your-people-spouse",
        omuserid: store.getters?.userId,
      });
      break;

    case "/people/marital-regime":
      window.dataLayer.push({
        event: "your-people-marital-regime",
        omuserid: store.getters?.userId,
      });
      break;

    case "/people/children":
      window.dataLayer.push({
        event: "your-people-children",
        omuserid: store.getters?.userId,
      });
      break;

    case "/people/add-children":
      window.dataLayer.push({
        event: "your-people-add-children",
        omuserid: store.getters?.userId,
      });
      break;

    case "/people/guardian":
      window.dataLayer.push({
        event: "your-people-childrens-guardian",
        omuserid: store.getters?.userId,
      });
      break;

    case "/people/trust":
      window.dataLayer.push({
        event: "your-people-trust",
        omuserid: store.getters?.userId,
      });
      break;

    case "/people/executor":
      window.dataLayer.push({
        event: "your-people-executor",
        omuserid: store.getters?.userId,
      });
      break;

    case "/people/optional-inheritors":
      window.dataLayer.push({
        event: "your-people-optional-inheritors",
        omuserid: store.getters?.userId,
      });
      break;

    case "/overview#your-people":
      window.dataLayer.push({
        event: "your-people-assets-added",
        omuserid: store.getters?.userId,
      });
      break;

    case "/world-wide-assets":
      window.dataLayer.push({
        event: "your-assets-world-wide-assets",
        omuserid: store.getters?.userId,
      });
      break;

    case "/assets-overview":
      window.dataLayer.push({
        event: "assets-overview",
        omuserid: store.getters?.userId,
      });
      break;

    case "/overview#your-assets":
      window.dataLayer.push({
        event: "overview-assets-added",
        omuserid: store.getters?.userId,
      });
      break;

    case "/specific-donations":
      window.dataLayer.push({
        event: "specific-donations",
        omuserid: store.getters?.userId,
      });
      break;

    case "/specific-donations-assets":
      window.dataLayer.push({
        event: "specific-donations-assets",
        omuserid: store.getters?.userId,
      });
      break;

    case "/specific-donations-money":
      window.dataLayer.push({
        event: "specific-donations-money",
        omuserid: store.getters?.userId,
      });
      break;

    case "/overview#specific-donations":
      window.dataLayer.push({
        event: "overview-specific-donations",
        omuserid: store.getters?.userId,
      });
      break;

    case "/remainder-of-estate/distribution":
      window.dataLayer.push({
        event: "remainder-of-estate-distribution",
        omuserid: store.getters?.userId,
      });
      break;

    case "/remainder-of-estate/alternative-distribution":
      window.dataLayer.push({
        event: "remainder-of-estate-alternative-distribution",
        omuserid: store.getters?.userId,
      });
      break;

    case "/overview#remainder-of-estate":
      window.dataLayer.push({
        event: "overview-remainder-of-estate",
        omuserid: store.getters?.userId,
      });
      break;

    case "/letter-of-wishes":
      window.dataLayer.push({
        event: "letter-of-wishes",
        omuserid: store.getters?.userId,
      });
      break;

    case "/living-will":
      window.dataLayer.push({
        event: "living-will",
        omuserid: store.getters?.userId,
      });
      break;

    case "/insurance/explanation":
      window.dataLayer.push({
        event: "insurance-explanation",
        omuserid: store.getters?.userId,
      });
      break;

    case "/insurance/estimated-insurance-required-input":
      window.dataLayer.push({
        event: "estimated-insurance-required-input",
        omuserid: store.getters?.userId,
      });
      break;

    case "/insurance/get-free-insurance-quote":
      window.dataLayer.push({
        event: "get-free-insurance-quote",
        omuserid: store.getters?.userId,
      });
      break;

    case "/insurance/insurance-quotes":
      window.dataLayer.push({
        event: "insurance-quotes",
        omuserid: store.getters?.userId,
      });
      break;

    case "/insurance/learn-more":
      window.dataLayer.push({
        event: "insurance-learn-more",
        omuserid: store.getters?.userId,
      });
      break;

    default:
      break;
  }
});

router.onError((error) => {
  if (/loading.* chunk .* failed./i.test(error.message)) {
    window.location.reload();
  }
});

export default router;
